<template>
	<div>
		<div :id="uuid" :content="text" v-tippy="{ theme : 'customTheme', placement : 'bottom-start', arrow : true }" style="text-overflow: ellipsis; width: 100%; overflow: hidden" >
			{{text}}
		</div>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

export default {
	name: "EllipsisTextCell",
	data() {
		return {
			data: {},
			uuid: "0",
			init: false,
			interval: null
		}
	},
	computed: {
        text () {
            var str = ""
            for(let i = 0; i < this.data.systems.length; i++){
                str += this.data.systems[i].name + ", "
            }
            if(str.endsWith(", ")){
                str = str.substring(0, str.length - 2);
            }
            return str;
        }
    },
	methods: {
		setVisible(){
			if(this.init) {
				try{
					let e = document.getElementById(this.uuid)
					let res = (e.offsetWidth < e.scrollWidth)
					if(res){
						e._tippy.enable()
					} else {
						e._tippy.disable()
					}
					clearInterval(this.interval);
				} catch (ignored) {

				}
			}
		},
	},
	mounted: async function(){
		this.uuid = uuidv4();
		this.init = true
		this.interval = setInterval(() => this.setVisible(), 50);
	},
}
</script>

<style>
.tippy-popper[x-placement^=bottom] .tippy-tooltip.customTheme-theme .tippy-arrow {
	border-bottom: 8px solid #346F8B;
}
</style>

<style scoped>
.tippy-tooltip.customTheme-theme {
	background-color: #346F8B;
}
</style>


// WEBPACK FOOTER //
// src/components/Systems/EllipsisTextCell.vue